module.exports = __webpack_public_path__ + "img/clipboards.673da0d1.svg";